module.exports = __webpack_public_path__ + "03_hige_black.b69b8e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/03_hige_black.png
// module id = jHVI
// module chunks = 0